import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

export enum AffinityConfig {
  HSR_FILTER_CODE = "hsrFilterCode",
  HSR_FILTERS = "hsrFilters",
  BEX_API_FILTERS = "bexApiFilters",
}

const starRatingMap = {
  "1 Star": 1,
  "2 Star": 2,
  "3 Star": 3,
  "4 Star": 4,
  "5 Star": 5,
};
export function getStarRating(flexContext: ExtendedContextStore): number | undefined {
  const starRatingCode: string | undefined =
    flexContext &&
    flexContext.searchContext &&
    flexContext.searchContext.starRating &&
    flexContext.searchContext.starRating.code;

  return starRatingMap[starRatingCode];
}

export function getHSRStarRatingCode(flexContext: ExtendedContextStore): number | undefined {
  const starRating = getStarRating(flexContext);

  return starRating && starRating * 10; // HSR accepts 10, 20, 30, 40, 50.
}

export function getAffinityAttribute(flexContext: ExtendedContextStore, key: string) {
  const affinity = (flexContext && flexContext.searchContext && flexContext.searchContext.affinity) || {};

  return affinity[key];
}

export function getHSRFilterCode(flexContext: ExtendedContextStore): string | undefined {
  return getAffinityAttribute(flexContext, AffinityConfig.HSR_FILTER_CODE);
}

export function getHSRFilters(flexContext: ExtendedContextStore): { [key: string]: string } | undefined {
  return getAffinityAttribute(flexContext, AffinityConfig.HSR_FILTERS);
}

export function getBEXApiFilters(flexContext: ExtendedContextStore): { [key: string]: string } | undefined {
  return getAffinityAttribute(flexContext, AffinityConfig.BEX_API_FILTERS);
}
export function getPropertyTypeCode(context: ExtendedContextStore): string | undefined {
  const srpPropertyTypeCode = context?.searchContext?.alternativeAccommodation?.lodgingUrlCode;

  if (srpPropertyTypeCode === null) {
    return undefined;
  }

  const bundlePropertyTypesFilters = ["APARTMENT", "APART_HOTEL", "CONDO", "VACATION_HOME", "CONDO_RESORT"];
  const bundlePropertyTypesTargets = ["APARTMENT", "APART_HOTEL", "VILLA", "CONDO", "VACATION_HOME", "CONDO_RESORT"];
  if (bundlePropertyTypesFilters.includes(srpPropertyTypeCode)) {
    return bundlePropertyTypesTargets.join(",");
  }

  return srpPropertyTypeCode;
}
